import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { IDevUser } from '..';
import { IBaseResponse } from './base-response.dto';

export interface IAdapter {
  _id?: string;
  name: string;
  url: string;
  token?: string;
  description: string;
  version: string;
  devUser: string | IDevUser;
  code?: string;
  createdAt?: Date;
}

/* -------------------------------------------------------------------------- */
/*                             Create new Adapter                             */
/* -------------------------------------------------------------------------- */

export class CreateAdapterDto {
  @IsNotEmpty()
  name: string;

  @IsOptional()
  description: string;

  @IsNotEmpty()
  version: string;

  @IsOptional()
  url: string;

  // we will get it from token (user decorator)
  @IsOptional()
  @IsString()
  devUser: string;

  @IsOptional()
  code?: string;
}

export interface CreateAdapterResponse extends IBaseResponse {
  id: string;
}
